<!--
 * @Author: Shao Wei
 * @Date: 2022-10-20 15:35:22
 * @LastEditors: Shao Wei
 * @LastEditTime: 2022-10-21 19:22:28
 * @Description: file content
 * @FilePath: /leopard-web-vehicle/src/views/finance/components/AlipayConfig.vue
-->
<template>
<div>
  <dialogWrap
    class="dialogWrap_position"
    v-model="isShow"

    title="支付宝支付定时配置"
    @change="changeHandle"
    :width="'450px'"
  >
    <AlipayConfigContent :alipayConfigData="alipayConfigData" ref="alipayContent"></AlipayConfigContent>
    <template slot="footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="changeConfig"
        >修改配置</el-button
      >
    </template>
  </dialogWrap>
  <!-- 二次确认弹窗 -->
  <dialogWrap
    v-model="confirmShow"

    title="请确认本次修改结果"
    :width="'524px'"
  >
    <el-form>
      <el-col :span="24">
        <el-form-item label="是否开启：">{{alipayConfigData.state === 1 ? '开启' : '关闭'}}</el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="执行时间（每天）：">{{withholdTimeFormatted}}</el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item>
          <p>*开启后，自动代扣「应收日期」为当日的应收项</p>
          <p>*代扣发起前，请确保应收已调整无误</p>
        </el-form-item>
      </el-col>
    </el-form>
    <template slot="footer">
      <el-button size="small" @click="cancelConfirm">取消</el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="onOk"
        >确认</el-button
      >
    </template>
  </dialogWrap>
</div>
</template>

<script>
import { postAlipayConfig } from '@/api/financeApi'
import AlipayConfigContent from '@/pages/finance/alipayConfigContent.vue'
import { debounce } from '@/utils'

export default {
  components: { AlipayConfigContent },
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    alipayConfigData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    show(val) {
      this.isShow = val
      this.$nextTick(() => {
        this.alipayContentRef = this.$refs.alipayContent
      })
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  data() {
    return {
      isShow: false,
      loading: false,
      confirmShow: false,
    }
  },
  computed: {
    withholdTimeFormatted() {
      return this.alipayConfigData.withholdTime.replaceAll('-', ':')
    },
  },
  methods: {
    changeHandle(bol) {
      if (!bol) {
        this.alipayContentRef.formResetFields()
      }
    },
    changeConfig() {
      this.alipayContentRef
        .formValidate()
        .then((res) => { this.confirmShow = true })
    },
    cancel() {
      this.isShow = false
      this.alipayContentRef.formResetFields()
    },
    cancelConfirm() { this.confirmShow = false },
    // 确认修改
    onOk: debounce(async function () {
      this.loading = true
      const { state, withholdTime } = this.alipayConfigData
      const { code, data } = await postAlipayConfig({
        alipayConfig: {
          state,
          withholdTime,
        },
      })
      this.loading = false
      if (code === 1) {
        this.confirmShow = false
        this.isShow = false
      }
    }, 500),
  },
}
</script>

<style scoped lang="scss">
.box-wrap {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.dialogWrap_position {

}
::v-deep .el-dialog{
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog_body {
  flex: 1;
  overflow: auto;
}
</style>
